import React from 'react';
import './cn-demo-rect.scss';
var CnDemoRect = function (props) {
    return (React.createElement("div", { className: "cn-ui-m-demo-rect", style: props.style }, props.children));
};
CnDemoRect.displayName = 'CnDemoRect';
export default CnDemoRect;
